import { reactive } from "vue";

export const mainStore = reactive({
  mode: "dark",
  user: null,
  pw: null,
  refresh_token: null,
  access_token: null,
  utente: {},
  abbonato: {},
  isLogged: false,
  perizia: {},
  perizie: [],
  kmPerizia: 0,
  isSendingCorrectionAvailable: false,
  datiSearchTargaTipoVeicoloSbagliato: {},

  // FORECAST
  isForecast: false,
  refresh_token_forecast: null,
  access_token_forecast: null,
  isLogged_forecast: false,
  type: null, //"auto", //null,
  mercato: null, //"nuovo", //null,
  cliente: {},
  login: {},
  forecast: {},
  /*forecast: {
    codiceEurotax: "3088129",
    forecastedValue: [
      {
        forecastDate: "",
        forecastPeriod: "6",
        totalMileage: "90000",
        tradeAmount: 13002.0,
        tradeValueInPercentage: 46.02,
        retailAmount: 14645.0,
        retailValueInPercentage: 51.84,
        totalTradeAmountOfEquipment: 0.0,
        totalRetailAmountOfEquipment: 0.0
      },
      {
        forecastDate: "",
        forecastPeriod: "18",
        totalMileage: "90000",
        tradeAmount: 12397.0,
        tradeValueInPercentage: 43.88,
        retailAmount: 14359.0,
        retailValueInPercentage: 50.83,
        totalTradeAmountOfEquipment: 0.0,
        totalRetailAmountOfEquipment: 0.0
      },
      {
        forecastDate: "",
        forecastPeriod: "36",
        totalMileage: "90000",
        tradeAmount: 11163.0,
        tradeValueInPercentage: 39.52,
        retailAmount: 13486.0,
        retailValueInPercentage: 47.74,
        totalTradeAmountOfEquipment: 0.0,
        totalRetailAmountOfEquipment: 0.0
      },
      {
        forecastDate: "",
        forecastPeriod: "72",
        totalMileage: "90000",
        tradeAmount: 9817.0,
        tradeValueInPercentage: 34.75,
        retailAmount: 12900.0,
        retailValueInPercentage: 45.66,
        totalTradeAmountOfEquipment: 0.0,
        totalRetailAmountOfEquipment: 0.0
      }
    ]
  },*/
  /*forecast: {
    codiceEurotax: "1147211",
    forecastedValue: [
      {
        forecastDate: "",
        forecastPeriod: "6",
        totalMileage: "90000",
        tradeAmount: 20637.0,
        tradeValueInPercentage: 41.19,
        retailAmount: 22559.0,
        retailValueInPercentage: 45.03,
        totalTradeAmountOfEquipment: 0.0,
        totalRetailAmountOfEquipment: 0.0
      },
      {
        forecastDate: "",
        forecastPeriod: "18",
        totalMileage: "90000",
        tradeAmount: 20392.0,
        tradeValueInPercentage: 40.7,
        retailAmount: 22498.0,
        retailValueInPercentage: 44.91,
        totalTradeAmountOfEquipment: 0.0,
        totalRetailAmountOfEquipment: 0.0
      },
      {
        forecastDate: "",
        forecastPeriod: "24",
        totalMileage: "90000",
        tradeAmount: 19802.0,
        tradeValueInPercentage: 39.52,
        retailAmount: 21949.0,
        retailValueInPercentage: 43.81,
        totalTradeAmountOfEquipment: 0.0,
        totalRetailAmountOfEquipment: 0.0
      },
      {
        forecastDate: "",
        forecastPeriod: "36",
        totalMileage: "90000",
        tradeAmount: 18358.0,
        tradeValueInPercentage: 36.64,
        retailAmount: 20537.0,
        retailValueInPercentage: 40.99,
        totalTradeAmountOfEquipment: 0.0,
        totalRetailAmountOfEquipment: 0.0
      }
    ]
  },*/
  allestimentoVeicolo: {},
  /*allestimentoVeicolo: {
    marcaNome: "FORD",
    versione: "transit custom 310 2.0 tdci 170cv Sport L1H1 E6",
  },*/
  /*allestimentoVeicolo: {
    marcaNome: "BMW",
    versione: "220i Coupe MSport auto",
  },*/
})